import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SdmUtilService } from './sdm-util.service';
import { ContentService } from './content.service';

@Injectable({ providedIn: 'root' })
export class UiHelperService {
	private sdmUtil = inject(SdmUtilService);
	private content = inject(ContentService);
	private snackBar = inject(MatSnackBar);
	public isAuthenticated: Promise<void>;
	public isAuthenticatedOrNot: Promise<boolean>;

	constructor(
	) {
		this.isAuthenticated = this.sdmUtil.isAuthenticated;
		this.isAuthenticatedOrNot = this.sdmUtil.isAuthenticatedOrNot;
	}

	public info(messageContentId: string): void {
		this.snackBar.open(
			this.content.getContent(messageContentId),
			'Close',
			{
				duration: 5000, // 5 seconds
				horizontalPosition: 'right',
				verticalPosition: 'top'
			}
		);
	}

	// TODO: Implement prompt dialog using Angular Material MatDialog if needed
	// public prompt(titleContentId: string, bodyContentId: string): Promise<void> {
	// 	// Use MatDialog.open() with custom component
	// }
}
